import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from '@atlassian/help-center-common-component/with-async';

export const ForgeRunnerModule = withAsync({
    loader: lazyForPaint(
        () => import(/* webpackChunkName: "forge-runner" */ /* webpackPreload: true */ './forge-runner')
    ),
    LoadingSkeleton: () => null,
});
